import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UpdateUser, UpdateUserDefaultValues } from '../update-user';
import { UserService } from 'src/app/services/user.service';
import { ProvinceService } from 'src/app/services/province.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { BranchService } from 'src/app/services/branch.service';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import {
  LLTTFInvitationQuery,
  LLTTFInvitationQueryDefaultValues,
} from '../../invitations/llttf-invitations/llttf-invitation-list';
import { AuthService } from 'src/app/services/auth.service';
import { Provinces } from 'src/app/components/global/province';
import { ApplicationRoles } from '../user-roles';

@Component({
    selector: 'app-edit-user-form',
    templateUrl: './edit-user-form.component.html',
    styleUrls: ['./edit-user-form.component.scss'],
    standalone: false
})
export class EditUserFormComponent implements OnChanges {
  @Input() updateUser: UpdateUser = UpdateUserDefaultValues();
  @Input() applicationRoles: any[] = [];
  selectedRoles: any[] = [];
  provinces: any[] = [];
  branch: any[] = [];
  org: any[] = [];
  llttfinvitaitonqueryfilter: LLTTFInvitationQuery =
    LLTTFInvitationQueryDefaultValues();
  cohorts: any[] = [];
  coachedUsers: any[] = [];
  filtereBranches: any[] = [];
  filteredOrgs: any[] = [];
  facilitators: any[] = [];
  filteredFacilitators: any[] = [];
  allowStatusChange = true;
  canEditEmail = false;
  // Branch Admins (any user) and Provincial Support (participants) may only change the
  // assigned coach; all other fields are read-only.
  isBranchAdmin = false;
  isProvincialSupport = false;
  isDivisionProgramLead = false;

  get coachOnly(): boolean {
    return this.isBranchAdmin || (this.isProvincialSupport && this.updateUser.isParticipant);
  }

  // Provincial Support / Division Program Lead stay within their own province when editing staff.
  get lockProvince(): boolean {
    return this.coachOnly || this.isProvincialSupport || this.isDivisionProgramLead;
  }
  private lltffLookupsLoaded = false;
  private orgLookupsLoaded = false;

  get hideBranchForOntario(): boolean {
    return this.updateUser.provinceId === Provinces.Ontario;
  }

  constructor(
    private userservice: UserService,
    public provinceservice: ProvinceService,
    public orgservice: OrganizationService,
    public branchservice: BranchService,
    public llttfservice: LlttfInvitationService,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.provinceservice.getProvinces().subscribe({
      next: (response) => {
        this.provinces = response;
      },
    });

    this.branchservice.getBranches().subscribe({
      next: (response) => {
        this.branch = this.filtereBranches = response;
      },
    });

    this.userservice.getCoachedUsers().subscribe({
      next: (response) => {
        this.coachedUsers = response;
      },
    });

    this.allowStatusChange =
      this.authService.getAccessControl().allowChangingUserStatus;
    this.canEditEmail = this.authService.getAccessControl().canEditEmail;
    const role = this.authService.getRole();
    this.isBranchAdmin = role === ApplicationRoles.BB_BranchAdmin;
    this.isProvincialSupport = role === ApplicationRoles.BB_ProvincialSupport;
    this.isDivisionProgramLead = role === ApplicationRoles.BB_DivisionProgramLead;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['updateUser'] && this.updateUser?.userDBId) {
      this.loadConditionalLookups();
    }
  }

  private loadConditionalLookups(): void {
    const access = this.authService.getAccessControl();

    if (!this.orgLookupsLoaded && (this.updateUser.isOrgVisible || access.orgManagement)) {
      this.orgLookupsLoaded = true;
      this.orgservice.getOrganizationForUser().subscribe({
        next: (resp) => {
          this.org = this.filteredOrgs = resp;
          this.bindBranches();
        },
      });
    }

    if (!this.lltffLookupsLoaded && (this.updateUser.isCohortVisible || this.updateUser.isFacilitatorVisible || access.llttfInvitations)) {
      this.lltffLookupsLoaded = true;

      if (this.updateUser.isCohortVisible || access.llttfInvitations) {
        this.llttfservice
          .getAlLLTTFInvitations(this.llttfinvitaitonqueryfilter)
          .subscribe({
            next: (response) => {
              this.cohorts = response.body ? response.body : [];
            },
          });
      }

      if (this.updateUser.isFacilitatorVisible || access.llttfInvitations) {
        this.userservice.getLLTTFFacilitatorUsers().subscribe({
          next: (response) => {
            this.facilitators = this.filteredFacilitators = response;
            this.bindFacilitators();
          },
        });
      }
    }
  }

  bindBranches() {
    if (this.updateUser.provinceId === Provinces.Ontario) {
      this.filtereBranches = [];
      this.updateUser.branchId = 0;
    } else {
      this.filtereBranches = this.branch.filter(
        (b) => b.provinceId == this.updateUser.provinceId,
      );
    }
    this.filteredOrgs = this.org.filter(
      (o) => o.provinceId == this.updateUser.provinceId,
    );
  }

  bindFacilitators() {
    this.filteredFacilitators = this.facilitators.filter(
      (f) => f.orgId == this.updateUser.orgId,
    );
  }
}
